<template>
  <v-app>
    <app-header></app-header>
    <v-content>
      <router-view>
      </router-view>
    </v-content>
    <app-footer></app-footer>
  </v-app>
</template>

<script>
  // import AppHeader from '@/components/AppHeader'
  // import AppFooter from '@/components/AppFooter'
  const AppHeader = () => import('@/components/AppHeader');
  const AppFooter = () => import('@/components/AppFooter');
  export default {
    components:{
      AppHeader,
      AppFooter
    }
  }
</script>

<style lang="scss" scoped>

</style>
